module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"Newsletter":{"heading":"Odběr newsletteru","text":"Přihlaste se k odběru našeho newsletteru a můžete se těšit na pravidelnou porci novinek a slev."}}}')
  delete Component.options._Ctor
}
